import { useFormContext } from 'react-hook-form'
import { ComponentOrderMessageVO } from '@repo/types/src/types/ComponentOrderMessageVO'
import { formatPaymentValue } from '../utils'

export const useSendOrderMessageFormInfo = () => {
  const { watch, setValue, control } = useFormContext<ComponentOrderMessageVO>()
  const type = watch('type')
  const item0 = watch('items')?.[0]

  const updateTitle = (eventOrValue: any) => {
    const value = eventOrValue?.target?.value ?? eventOrValue
    setValue('items.0.name', value, { shouldValidate: true })
  }

  const updatePrice = (maskedValue: any) => {
    setValue('items.0.price', maskedValue, { shouldValidate: true })
  }

  const updatePaymentValue = (eventOrValue: any) => {
    const raw = eventOrValue?.target?.value ?? eventOrValue

    const formatted = formatPaymentValue(raw, type)

    setValue('value', formatted, { shouldValidate: true })
  }

  return {
    type,
    item0,
    updateTitle,
    updatePrice,
    updatePaymentValue,
    control
  }
}
